<template>
    <div class="paginationBlock">
        <div class="pagination no-padding">
            <a href="#" class="button pink smallsize small caps">&#8249; Prev</a>
            <div v-if="totalCount" class="page-info">
                Page <a href="#">{{currentPage}}</a> of <a href="#">{{totalCount}}</a>
            </div>
            <a href="#" class="button pink smallsize small caps">Next &#8250;</a>
        </div>

    </div>
</template>

<script>
export default {
    name: "PaginationComponent",
    props: ['totalCount', 'currentPage']
}
</script>
